export default __webpack_public_path__ + "static/media/water4.f0dd8a0a.png";